export default {
  type: 'Typ',
  all: 'Alle',
  analysis: 'Werkstoffanalyse',
  specification: 'Werkstoffspezifikation',
  analysisList: 'Werkstoffanalysen',
};
